import { render, staticRenderFns } from "./AgmPrivacy.vue?vue&type=template&id=9db0aae6&scoped=true"
var script = {}
import style0 from "./AgmPrivacy.vue?vue&type=style&index=0&id=9db0aae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db0aae6",
  null
  
)

export default component.exports